import axiosCore from 'axios'
import firebase from 'firebase/app';
import 'firebase/auth';
export default class FBAxios {

  get instance() {
    return this.axiosInstance;
  }
  set instance(instance) {
    this.axiosInstance = instance;
  }
  constructor(url, region, msTimeout) {
    this.options=firebase.app().options
    if (region) {
      this.region = region;
    } else {
      this.region = 'us-central1'
    }
    if (url) {
      this.useEmulator(url);
    } else {
      this.useProduction();
    }
    this.msTimeout = msTimeout || 30000;

    this.axiosInstance = axiosCore.create({
      headers: {
        "Content-Type": "text/plain"
      },
      transformRequest: data => {
        return JSON.stringify(data);
      }
    });
  }
  async call(fn, data, headers) {
    // envia el tenant en cada funcion
    data.tenant = this.tenant;
    const sendData = {
      headers: headers ? headers : {},
      data: data ? data : {}
    };

    const user = firebase.auth().currentUser;
    if (user) {
      const token = await user.getIdToken();
      sendData.headers.authorization = `Bearer ${token}`;
    }
    let response;
    if (this.msTimeout) {
      response = await timedOutPromise(this.msTimeout, this.axiosInstance.post(this.url + fn, sendData))
    } else {
      response = await this.axiosInstance.post(
        this.url + fn,
        sendData
      );
    }

    return response.data;
  }
  setTenant(tenant){
    this.tenant = tenant
    return this;
  }
  changeRegion(region) {
    this.region = region;
    return this;
  }
  useProduction() {
    this.url = `https://${this.region}-${this.options.projectId}.cloudfunctions.net/`;
    return this;
  }
  useEmulator(url) {
    this.url = `${url}/${this.options.projectId}/${this.region}/`;
    return this;
  }
}

function timedOutPromise(ms, promise) {
  return new Promise(function (resolve, reject) {
    promise.then(function (val) {
      resolve(val)
    })
    setTimeout(function () {
      reject({data:{
        ok:false,
        message:"Prueba"
      }})
    }, ms)
  })
}